var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloseWithoutCircle = function SvgCloseWithoutCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "close",
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.278 4.222 4.72 19.778M4.722 4.222l15.556 15.556",
    stroke: "#000",
    strokeLinecap: "round"
  })));
};
export default SvgCloseWithoutCircle;